import React from 'react'
import CheckHeaderIcon from '../../components/SvgIcon/icons/CheckHeaderIcon'
import ErrorIcon from '../../components/SvgIcon/icons/ErrorIcon'

const StatusIcon = ({ status }) => {
  return <>{status === 'success' ? <CheckHeaderIcon /> : <ErrorIcon />}</>
}

export default StatusIcon
